import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AbpHttpInterceptor } from "abp-ng2-module";

import * as ApiServiceProxies from "./service-proxies";
import { DashboardServiceProxy } from "./dashboard-service-proxy";

@NgModule({
  providers: [
    ApiServiceProxies.EmployeeServiceProxy,
    ApiServiceProxies.EmployeeJobServiceProxy,
    ApiServiceProxies.JobServiceProxy,
    ApiServiceProxies.GroupServiceProxy,
    ApiServiceProxies.CarBrandServiceProxy,
    ApiServiceProxies.CarModelServiceProxy,
    ApiServiceProxies.CustomerServiceProxy,
    ApiServiceProxies.NationalityServiceProxy,
    ApiServiceProxies.ServiceServiceProxy,
    ApiServiceProxies.TokenAuthProxy,
    ApiServiceProxies.VehicleServiceProxy,
    ApiServiceProxies.ConfigurationProxy,
    ApiServiceProxies.ServiceStepServiceProxy,
    ApiServiceProxies.OfferServiceProxy,
    ApiServiceProxies.ServicePriceServiceProxy,
    ApiServiceProxies.ServiceCheckListServiceProxy,
    ApiServiceProxies.TransactionServiceProxy,
    ApiServiceProxies.BillDetailsServiceProxy,
    ApiServiceProxies.RoleProxy,
    ApiServiceProxies.UserProxy,
    ApiServiceProxies.TenantProxy,
    ApiServiceProxies.AccountProxy,
    ApiServiceProxies.SessionProxy,
    ApiServiceProxies.TokenAuthProxy,
    ApiServiceProxies.CommissionCalculationServiceProxy,
    ApiServiceProxies.ReportServiceProxy,
    ApiServiceProxies.ShiftServiceProxy,
    ApiServiceProxies.PaymentMethodServiceProxy,
    DashboardServiceProxy,
    { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
  ],
})
export class ServiceProxyModule { }
